import clsx from 'clsx';
import { startOfDay, subDays } from 'date-fns';
import React, { useMemo } from 'react';

import { useCatalystInsightsList } from '~/react-query-hooks/insights/useCatalystInsights';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';
import { CatalystInsightPill } from '~/widgets/catalyst-insights-drawer/catalyst-insight-pill/CatalystInsightPill';

import { ThemeLogoIcon } from '../theme-logo-icon/ThemeLogoIcon';
import styles from './ThemeHeader.module.scss';

interface LegacyThemeHeaderProps {
  themeId: string;
  themeName: string;
  logo_url?: string;
  isCondensed?: boolean;
}

export const LegacyThemeHeader = ({
  themeId,
  themeName,
  logo_url,
  isCondensed = false,
}: LegacyThemeHeaderProps) => {
  const fromDate = useMemo(() => startOfDay(subDays(new Date(), 3)), []);
  const { data: catalystInsightsData } = useCatalystInsightsList({
    themes: [themeId],
    categories: ['market_wide'],
    from: fromDate.toISOString(),
    page: 1,
    page_size: 1,
  });

  return (
    <div className={styles.flexRow}>
      <div
        className={clsx(styles.logoAndTitle, {
          [styles.condensed]: isCondensed,
        })}
      >
        <ThemeLogoIcon
          logo_url={logo_url}
          name={themeName}
          key={themeName}
          isCondensed={isCondensed}
        />
        <span
          className={clsx(styles.titleText, {
            [styles.condensed]: isCondensed,
          })}
        >
          {themeName}
        </span>
      </div>
      {!!catalystInsightsData?.length && (
        <CatalystInsightPill
          insightId={catalystInsightsData[0].id}
          themeId={themeId}
          subCategory={catalystInsightsData[0].sub_category}
          isClickable
          source={POSTHOG_TRACKING_SOURCES.THEME_OVERVIEW}
          category={catalystInsightsData[0].category}
        />
      )}
    </div>
  );
};
